import { assertIsBrowser } from '../utils/assertIsBrowser.js';
assertEnvClient();
function assertEnvClient() {
    assertIsBrowser();
}
